import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener('click', this.#handleGiftUpsellClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('click', this.#handleGiftUpsellClick);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #handleGiftUpsellClick = async (event) => {
    const button = event.target.closest('[data-gift-variant-id]');
    if (!button) return;

    event.preventDefault();

    const variantId = button.dataset.giftVariantId;
    if (!variantId) return;

    const cartItemsComponent = this.querySelector('cart-items-component');
    const sectionId = cartItemsComponent?.dataset.sectionId;
    const originalText = button.textContent;

    try {
      button.disabled = true;
      button.textContent = 'Agregando...';

      const payload = {
        id: Number(variantId),
        quantity: 1,
      };

      if (sectionId) {
        payload.sections = [sectionId];
        payload.sections_url = window.location.pathname;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('No se pudo agregar la bolsa al carrito.');
      }

      const data = await response.json();

      if (sectionId && data.sections && data.sections[sectionId]) {
        const parsed = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
        const newCartItemsComponent = parsed.querySelector('cart-items-component');

        if (newCartItemsComponent && cartItemsComponent) {
          cartItemsComponent.replaceWith(newCartItemsComponent);
        }
      } else {
        const cartResponse = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json',
          },
        });

        if (!cartResponse.ok) {
          throw new Error('No se pudo refrescar el carrito.');
        }
      }

      const cartBubble = document.querySelector('cart-bubble-component, .cart-bubble, [data-cart-bubble]');
      if (cartBubble) {
        document.dispatchEvent(new CustomEvent(CartAddEvent.eventName));
      }

      this.showDialog();
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = originalText;
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}